import Reveal from "./Reveal";

export default function ChapterHeader({ num, overline, title, subtitle, id }) {
  return (
    <div id={id} className="container-x pt-24 md:pt-32">
      <div className="grid grid-cols-12 gap-6 md:gap-8 items-end">
        <Reveal className="col-span-3 md:col-span-2" y={40}>
          <div className="chapter-num text-6xl md:text-8xl lg:text-9xl leading-none">
            {num}
          </div>
        </Reveal>
        <div className="col-span-9 md:col-span-10">
          <Reveal delay={0.05}>
            <div className="flex items-center gap-3 text-[10px] md:text-xs uppercase tracking-[0.3em] text-[var(--text-muted)] font-display">
              <span className="w-6 h-[1px] bg-[var(--accent)]" />
              {overline}
            </div>
          </Reveal>
          <Reveal delay={0.1} y={30}>
            <h2 className="mt-4 font-display font-black uppercase leading-[0.95] tracking-tighter text-5xl md:text-7xl lg:text-8xl text-[var(--text)]">
              {title}
            </h2>
          </Reveal>
          {subtitle && (
            <Reveal delay={0.18}>
              <p className="mt-6 text-[var(--text-muted)] text-base md:text-lg max-w-2xl leading-relaxed">
                {subtitle}
              </p>
            </Reveal>
          )}
        </div>
      </div>
    </div>
  );
}
